import { Injectable } from '@angular/core';

const TOKEN_KEY = 'AuthToken';
const TENANT_ID = 'tenant';

@Injectable()
export class TokenStorage {

  constructor() {
  
   }

  signOut() {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.clear();
  }

  public saveToken(token: string) {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    
    let tokenStr = sessionStorage.getItem(TOKEN_KEY);

    if (tokenStr != null) {
      let token = tokenStr.split(" ");
      
      return token[0];
    }

    return tokenStr;
  }

  public getTenant(): string {
    let tokenStr = sessionStorage.getItem(TOKEN_KEY);

    if (tokenStr != null) {
      let token = tokenStr.split(" ");
    
      return token[1];
    }

    return tokenStr;
  }

  public saveCustomerType(key: string, type: string) {
    window.sessionStorage.removeItem(key);
    window.sessionStorage.setItem(key, type);
  }

  public getCustomerType(): string {
    let tokenStr = sessionStorage.getItem("CUSTOMER_TYPE");
    return tokenStr;
  }
}
